module.exports = __webpack_public_path__ + "static/media/spotify.79e157ad.jpg";